import { useQuery } from "@tanstack/react-query"
import { notificationsQueryKeys } from "../query-keys"
import { getNotificationCount } from "../services"
import { NOTIFICATION_REFETCH_INTERVAL } from "../../../toptaal-shared/src/constants"

export const useNotificationCountQuery = () => {
  return useQuery({
    queryKey: notificationsQueryKeys.count(),
    queryFn: getNotificationCount,
    select: (data) => data.data.unreadCount,
    refetchInterval: NOTIFICATION_REFETCH_INTERVAL,
  })
}
